import { DateTime } from "luxon";

export const DEFAULT_TIME_FORMAT = "HH:mm:ss";
export const LocalTimeParser = (time: string): Date => DateTime.fromFormat(time, DEFAULT_TIME_FORMAT.replace('HH', 'HH').replace('mm', 'mm').replace('ss', 'ss')).toJSDate();
export const UTCTimeParser = (time: string, baseDate: Date|false = false): Date => {
    if (!baseDate) {
        return DateTime.fromFormat(time, DEFAULT_TIME_FORMAT.replace('HH', 'HH').replace('mm', 'mm').replace('ss', 'ss')).toJSDate();
    }
    else {
        const dateStr = DateTime.fromJSDate(baseDate).toFormat("yyyy-MM-dd");
        return DateTime.fromISO(`${dateStr}T${time}`).toJSDate();
    }
};
